// PaymentsTab -- e-Transfers received from one customer (from the
// e-Transfers page / Outlook sync), newest first.

import { useEffect, useState } from 'react';
import axios from 'axios';
import { fmtMoney, fmtDate, InvoiceInfo, SiteCell } from '../pages/Etransfers.jsx';

export default function PaymentsTab({ contactId }) {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  useEffect(() => {
    setData(null);
    axios.get('/api/etransfers', { params: { contact_id: contactId, status: 'matched' } })
      .then((r) => setData(r.data))
      .catch((e) => setError(e.response?.data?.error || e.message));
  }, [contactId]);

  if (error) return <p className="calls-error">Could not load payments: {error}</p>;
  if (!data) return <p className="calls-dim">Loading payments…</p>;
  return (
    <div>
      <div className="calls-tab-summary">
        <span><strong>{data.totals.count}</strong> payment{data.totals.count === 1 ? '' : 's'}</span>
        <span><strong>{fmtMoney(data.totals.total)}</strong> received</span>
      </div>
      {data.rows.length === 0
        ? <p className="calls-dim">No payments matched to this customer yet. Unmatched ones can be assigned on the Payments page.</p>
        : (
          <div className="et-table-wrap">
            <table className="et-table">
              <thead><tr><th>Date</th><th className="et-num">Amount</th><th>From</th><th>Message</th><th>Site</th></tr></thead>
              <tbody>
                {data.rows.map((r) => (
                  <tr key={r.id}>
                    <td className="et-date">{fmtDate(r.received_at)}</td>
                    <td className="et-num et-amount">{fmtMoney(r.amount)}<div><span className={`et-method et-method-${r.method || 'etransfer'}`}>{r.method === 'eft' ? 'EFT' : 'e-Transfer'}</span></div></td>
                    <td>{r.sender_name}{r.reference && <div className="calls-sub">{r.method === 'eft' ? r.reference : `Ref ${r.reference}`}</div>}</td>
                    <td className="et-msg">{r.message || <span className="calls-dim">No message</span>}<InvoiceInfo r={r} /></td>
                    <td>{(r.site_id || (r.invoice_lines || []).some((l) => l.site_id)) ? <SiteCell r={r} /> : <span className="calls-dim">—</span>}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
    </div>
  );
}
